export default __webpack_public_path__ + "static/media/me_and_friends_at_san_pedro_beach.158ef3f4.jpg";